export const selectParentAppName = state => state.parentApp.appName;
export const selectPlugins = state => state.parentApp.plugins;
export const selectAiSettings = state => state.parentApp.aiSettings;
export const selectCopilotThreadIdQueryParam = state => {
  var _state$parentApp$quer;
  return (_state$parentApp$quer = state.parentApp.queryParams) === null || _state$parentApp$quer === void 0 ? void 0 : _state$parentApp$quer.copilotThreadId;
};
export const selectCopilotActionQueryParam = state => {
  var _state$parentApp$quer2;
  return (_state$parentApp$quer2 = state.parentApp.queryParams) === null || _state$parentApp$quer2 === void 0 ? void 0 : _state$parentApp$quer2.copilotAction;
};